import React from "react";
import $ from 'jquery';

class AttachCustomer extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            timeoutId: null,
            customers: []
        }
    }

    customerList = async () => {



        try {

            let searchTerm = $('#searchTerm').val();

            

            const res = await this.props.customerService.customerList('', searchTerm);

            if (res.ok) {

                this.setState({
                    customers: await res.json()
                });
            }



        } catch (error) {

            console.log(error);

        }


    }

    findCustomers = () => {



        let timer;

        clearTimeout(this.state.timeoutId);

        timer = setTimeout(() => {
            this.customerList();
        }, 2000);

        this.setState({ timeoutId: timer })



    }


    render() {

        const customers = this.state.customers;

        return (

            <div className='customer-wrapper'>

                <div className='container form-wrapper'>

                    

                    <div className="form-group">
                        <input className="form-control" onKeyUp={this.findCustomers} id="searchTerm" placeholder="Nom ou address" />
                    </div>





                </div>

                
                <div className='container'>

                    <p id="attach-order-status"></p>

                    {customers.length > 0 && customers.map(customer =>

                        <div className="card card-default mt-2" key={customer.customerId}>

                            <div className="card-body">
                                <div className="row">
                                    <div className="col">{customer.name}</div>

                                    <div className="col">{customer.address}</div>
                                    <div className="col">
                                        <button className="btn btn-primary" onClick={(e) =>this.props.attachCustomerToOrder(e,customer.customerId)}>Attach</button>
                                    </div>



                                </div>
                            </div>

                        </div>


                    )}

                </div>

            </div>
        );
    }


}


export default AttachCustomer;